export function capitalizeFirstLetter(string) {
    if (!string) {
        return '';
    }

    const firstCodePoint = string.codePointAt(0);
    const index = firstCodePoint > 0xFFFF ? 2 : 1;

    return String.fromCodePoint(firstCodePoint).toUpperCase() +
        string.slice(index);
}

export function convertAmps(string) {
    return string.replace('&amp;', '&');
}
